/* eslint-disable */
import Vue from "vue";

/**
 * 设置基础URL
 */
let base = "/apiv1/resource";

/**
 * 获取当前登录的用户资源树
 */
export const queryUserResourceTree = params => {
  return Vue.fetch.post(`${base}/queryUserResourceTree`, params);
};

/**
 * 添加资源
 */
export const add = params => {
  return Vue.fetch.post(`${base}/add`, params);
};

/**
 * 修改资源
 */
export const update = params => {
  return Vue.fetch.post(`${base}/update`, params);
};

/**
 * 删除资源
 */
export const remove = params => {
  return Vue.fetch.post(`${base}/remove`, params);
};

// 缓存对象
let GroupMap = {};

export const getResourceByGroupName = groupName => {
  let loginName = sessionStorage.getItem("loginName");
  let tempName = groupName + loginName;
  if (!groupName) {
    return Promise.resolve([]);
  }
  if (GroupMap[tempName] && GroupMap[tempName].data) {
    return Promise.resolve(GroupMap[tempName].data);
  }
  if (GroupMap[tempName] && GroupMap[tempName].loading) {
    return GroupMap[tempName].promise;
  }
  GroupMap[tempName] = {};
  GroupMap[tempName].loading = true;
  let params = {
    groupName: groupName
  };
  GroupMap[tempName].promise = Vue.fetch
    .post(`${base}/getResourceByGroupName`, params)
    .then(data => {
      GroupMap[tempName].data = data.payload.results.resource;
      return data.payload.results.resource;
    });
  return GroupMap[tempName].promise;
};



// WEBPACK FOOTER //
// ./src/cdpBase/services/resource.js